import { Instance } from 'mobx-state-tree';
import { PlanningActionOutputDtoModelBase } from './PlanningActionOutputDtoModel.base';

/* The TypeScript type of an instance of PlanningActionOutputDtoModel */
export interface PlanningActionOutputDtoModelType extends Instance<typeof PlanningActionOutputDtoModel.Type> {}

/* A graphql query fragment builders for PlanningActionOutputDtoModel */
export { selectFromPlanningActionOutputDto, planningActionOutputDtoModelPrimitives, PlanningActionOutputDtoModelSelector } from './PlanningActionOutputDtoModel.base';

/**
 * PlanningActionOutputDtoModel
 */
export const PlanningActionOutputDtoModel = PlanningActionOutputDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
